import { createContext, useContext } from 'react';

export interface ToastEntry {
  id: number;
  message: string;
  detail?: string;
  level: 'success' | 'error' | 'warning' | 'info' | 'neutral';
  action?: { label: string; onClick: () => void };
}

export type ToastInput = Omit<ToastEntry, 'id'>;

export const ToastContext = createContext<{ toast: (props: ToastInput) => void }>({
  toast: () => {},
});

export function useToast() {
  return useContext(ToastContext);
}
